




















import {Component, Vue} from 'vue-property-decorator'
import SwapPoweredBy from '@/components/SwapPoweredBy.vue'
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

@Component({
  components: {
    SwapPoweredBy,
    MoonLoader,
  },
})
export default class SwapLoadingStep extends Vue {}
